module.exports = __webpack_public_path__ + "assets/img/reproduction-img1-57d0b751.jpg";